import * as React from 'react'
import { FC } from 'react'
import { SideDrawer } from '@sales-center/components'
import { useStyle } from './styling'
import { IDiscountCode } from '@user/store/discountCode/typings'
import { ReferralDiscountDetails } from './Contents/ReferralDiscountDetails'
import Box from '@mui/material/Box'

interface Props {
  onClose: () => void
  open: boolean
  referralDiscountCode: IDiscountCode
}

export const ReferralDiscountDetailsDrawer: FC<Props> = (props) => {
  const { onClose, open } = props

  return (
    <SideDrawer onClose={onClose} open={open} title="REFERRAL DISCOUNT DETAILS">
      <Box sx={useStyle.container}>
        <ReferralDiscountDetails {...props} />
      </Box>
    </SideDrawer>
  )
}
